import React from 'react'
import PropTypes from 'prop-types'

import flash from '/lib/flash'

# CF keys docs: https://developers.cloudflare.com/turnstile/troubleshooting/testing/
keys =
  managed:   process.env.CLOUDFLARE_TURNSTILE_SITE_KEY_MANAGED
  invisible: process.env.CLOUDFLARE_TURNSTILE_SITE_KEY_INVISIBLE


export default \
class Turnstile extends React.Component
  @propTypes:
    onChange: PropTypes.func.isRequired
    onError:  PropTypes.func

  constructor: ->
    super arguments...
    @state =
      mode: 'invisible'
  
  tryRenderTurnstile: =>
    if not window.turnstile?
      interval = setInterval =>
        if window.turnstile?
          clearInterval interval
          @renderTurnstile()
      , 200
      return
    @renderTurnstile()

  componentDidMount: ->
    @tryRenderTurnstile()

  renderTurnstile: =>
    return unless keys.managed? and keys.invisible?
    mode = @state.mode

    widget_id = turnstile?.render @refs.turnstileContainer,
      sitekey: keys[mode]
      callback: (token) =>
        @props.onChange mode, token
      'error-callback': =>
        if mode is 'invisible'
          @setState mode: 'managed'
          turnstile.remove widget_id
          @renderTurnstile()
        else
          @props.onError? "Turnstile validation failed"
      size: 'flexible'

  render: ->
    <div data-theme="light" className="Turnstile" ref="turnstileContainer"></div>
